import * as React from 'react';
import '../../LT/analyticsresults/ViewAllDetails.css';
import ButtonComponent from '../../../components/common/button/Button';
import Modal from '../../../components/common/modal/Modal';

const OutBoundDataModal = ({ openOutboundModal, handleCloseOutboundModal, data, selectedName }) => {

    const handleCloseGraphModal = () => {
        handleCloseOutboundModal();
    }

    return (
        <div>
            <Modal
                className="LeadTimeModal_cls"
                open={openOutboundModal}
                handleClose={handleCloseGraphModal}
                title={selectedName === "Contracts" ? "Contract Details" : selectedName === "materialMaster" ? "Material Master Details" : "PIR Details"}
                action={
                    <OutBoundModalFooter
                        className="viewAllDetails_cls"
                        handleCloseModal={handleCloseGraphModal}
                    />
                }
                content={
                    <OutBoundModalContent data={data} selectedName={selectedName} />
                }
            />
        </div>
    )
}
export default OutBoundDataModal;

const OutBoundModalContent = ({ data, selectedName }) => {
    return (
        <div style={{ width: 700, height: 300, position: "relative" }}>
            {selectedName === "Contracts" &&
                data?.contractItems && data?.contractItems?.length !== 0 ?
                data?.contractItems?.map((item, index) => {
                    return (
                        <div >
                            {index === 0 && <div className='outboundModalContent' >
                                <p>Contract Number</p>
                                <p>Item No</p>
                                <p>Error Message</p>
                                <p>Status</p>
                                <p>Updated At</p>
                            </div>}
                            <div className='outboundModalContent' >
                                <span><a href={`${process.env.REACT_APP_SAP_FIORI_CONTRACT_DISPLAY_BASE_URL}?PurchaseContract=${item?.contractNumber}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{item?.contractNumber || "-"}</a></span>
                                <span>{item?.contractItem || "-"}</span>
                                <span>{item?.errorMessage || "-"}</span>
                                <span>{item?.status || "-"}</span>
                                <span>{item?.modifiedAt || "-"}</span>
                            </div>
                        </div>)
                })
                :
                selectedName === "Contracts" && data?.contractItems?.length === 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <p>No Active Contract Available now for the Supplier-Material-Incoterm Location-Plant</p></div>
            }
            {selectedName === "PIR" && data?.pirNumber?.length > 0 ?
                <div >
                    <div className='outboundModalContent'>
                        <p>PIR Number</p>
                        <p>Error Message</p>
                        <p>Status</p>
                        <p>Updated At</p>
                    </div>
                    <div className='outboundModalContent'>
                        <span><a href={`${process.env.REACT_APP_SAP_FIORI_PIR_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#PurchasingInfoRecord-displayFactSheet?Material=${data?.materialId}&PurchasingInfoRecord=${data?.pirNumber}&Supplier=${data?.supplierId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{data?.pirNumber || "-"}</a></span>
                        <span>{data?.s4ErrorMessage || "-"}</span>
                        <span>{data?.pirUpdateStatus || "-"}</span>
                        <span>{data?.pirUpdatedTsp || "-"}</span>
                    </div>
                </div>
                :
                selectedName === "PIR" && data?.pirNumber?.length === 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <p>No Active PIR Available now for the Supplier-Material-Plant/Purchasing Org</p></div>
            }
            {selectedName === "materialMaster" && data?.materialId?.length > 0 ?
                <div >
                    <div className='outboundModalContent'>
                        <p>Material</p>
                        <p>Plant</p>
                        <p>PDT Updated</p>
                        <p>Status</p>
                        <p>Error Message</p>
                        <p>Updated At</p>
                    </div>
                    <div className='outboundModalContent'>
                        <span><a href={`${process.env.REACT_APP_SAP_FIORI_MATERIAL_MASTER_DISPLAY_BASE_URL}?sap-client=010&sap-language=EN#Material-display?Material=${data?.materialId}`} target="_blank" style={{ color: '#000', cursor: 'pointer' }}>{data?.materialId || "-"}</a></span>
                        <span>{data?.plant || "-"}</span>
                        <span>{data?.mmUpdatedLt || "-"}</span>
                        <span>{data?.mmUpdateStatus || "-"}</span>
                        <span>{data?.mdgErrorMessage || "-"}</span>
                        <span>{data?.mmModifiedTsp || "-"}</span>
                    </div>
                </div>
                :
                selectedName === "materialMaster" && data?.materialId?.length === 0 && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> <p>No Material Available now for the Supplier-Material-Plant/Purchasing Org</p></div>
            }
        </div>
    );
}

const OutBoundModalFooter = ({ handleCloseModal }) => {
    return (
        <div style={{ display: 'flex', width: '100%', justifyContent: 'end' }}>
            <ButtonComponent
                maxWidth="170px"
                label="Close"
                type="primary"
                onClick={handleCloseModal}
            />
        </div>
    )
}